window.__bloomberg__ = window.__bloomberg__ || {};
